import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';
import { messageCompiler } from '@/shared/utils/messageCompiler';
import { DEFAULT_LOCALE, type Locale } from '@/shared/constants/locales';

const i18n = createI18n({
    legacy: false,
    locale: DEFAULT_LOCALE,
    messageCompiler,
});

export async function changeLocale(lang: Locale) {
    i18n.global.locale.value = lang;

    document.querySelector('html')?.setAttribute('lang', lang);

    const modules = import.meta.glob<Record<string, string>>(`../../i18n/*/*.json`);
    const regexLang = /\/i18n\/([^/]+)\//;
    const regexModule = /\/([^/]+)\.json$/;

    const entries = await Promise.all(
        Object.entries(modules)
            .filter(([path]) => regexLang.exec(path)?.[1] === lang)
            .map(async ([path, load]) => {
                const moduleName = regexModule.exec(path)?.[1] ?? path;
                const value = (await load()).default;
                return [moduleName, value] as const;
            })
    );
    const messages = Object.fromEntries(entries);

    i18n.global.setLocaleMessage(lang, messages);

    return nextTick();
}

export { i18n };
